var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{attrs:{"id":"home"}},[_c('Gate2026'),_c('main',[_c('Header'),_c('BannerMain'),_c('Rules'),_c('ShopsMap'),_c('ContactUs'),_c('Footer')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }